import React, { useState } from 'react'

import FilterIcon from 'presentation/assets/icons/funnel.svg'

import * as S from './styles'
import { DoctorRegisterStepNames } from 'domain/entities/doctor-register-step-names-model'

type StatusFilterProps = {
  onChange(value: DoctorRegisterStepNames): void
}

export default function PendenciesFilter({ onChange }: StatusFilterProps) {
  const [selectedFilter, setSelectedFilter] =
    useState<DoctorRegisterStepNames>()

  const options = [
    {
      label: 'Dados pessoais',
      abbr: 'PES.',
      value: DoctorRegisterStepNames.PERSONAL_DATA
    },
    {
      label: 'Dados profissionais',
      abbr: 'PROF.',
      value: DoctorRegisterStepNames.PROFESSIONAL_DATA
    },
    {
      label: 'Contatos',
      abbr: 'CONT.',
      value: DoctorRegisterStepNames.CONTACTS
    },
    {
      label: 'Endereço',
      abbr: 'END.',
      value: DoctorRegisterStepNames.ADDRESS
    },
    {
      label: 'Imunização',
      abbr: 'IMU.',
      value: DoctorRegisterStepNames.IMUNNIZATION
    },
    {
      label: 'Privilégios',
      abbr: 'PRIV.',
      value: DoctorRegisterStepNames.MEDICAL_PRIVILEGES
    },
    {
      label: 'Atendimentos',
      abbr: 'ATEN.',
      value: DoctorRegisterStepNames.ATTENDANCES
    },
    // {
    //   label: 'CNES',
    //   abbr: 'CNES',
    //   value: DoctorRegisterStepNames.CNES
    // },
    // {
    //   label: 'Treinamentos',
    //   abbr: 'TREIN.',
    //   value: DoctorRegisterStepNames
    // },
    {
      label: 'Setores de Atuação',
      abbr: 'SET.',
      value: DoctorRegisterStepNames.SECTORS_OF_ACTIVITY
    },
    {
      label: 'Equipes',
      abbr: 'EQUI.',
      value: DoctorRegisterStepNames.TEAMS
    },
    // {
    //   label: 'Crachás',
    //   abbr: 'CRA.',
    //   value: DoctorRegisterStepNames.PERSONAL_DATA
    // },
    // {
    //   label: 'SEN.',
    //   abbr: 'Senhas',
    //   value: DoctorRegisterStepNames.PERSONAL_DATA
    // },
    // {
    //   label: 'V. F.',
    //   abbr: 'Validação da fonte',
    //   value: DoctorRegisterStepNames
    // },
    {
      label: 'Documentos e Anexos',
      abbr: 'DOCS.',
      value: DoctorRegisterStepNames.DOCUMENTS_AND_ATTACHMENTS
    }
  ]

  const handleChangeFilter = (status: DoctorRegisterStepNames) => {
    setSelectedFilter(status)
    onChange(status)
  }

  const getLabelByStatus = (status: DoctorRegisterStepNames) => {
    const item = options.find((item) => item.value === status)
    return item ? item.label : ''
  }

  return (
    <S.Wrapper>
      <S.StyledSelect
        variant="outlined"
        value={selectedFilter}
        displayEmpty
        renderValue={(item) => {
          if (!selectedFilter) {
            return (
              <S.NoFilterSelected>
                <img src={FilterIcon} alt="Ícone de filtro" />
                <label>Filtrar por tipo de pendência: </label>
              </S.NoFilterSelected>
            )
          }
          return (
            <S.FilterSelected>
              <S.PendencyAbbr>
                <div>
                  {
                    options.find(
                      (val) => val.value === (item as DoctorRegisterStepNames)
                    )?.abbr
                  }
                </div>
              </S.PendencyAbbr>
              <label>{getLabelByStatus(selectedFilter)}</label>
            </S.FilterSelected>
          )
        }}
        onChange={(e) => {
          handleChangeFilter(e.target.value as DoctorRegisterStepNames)
        }}
      >
        {options.map((item) => (
          <S.StyledMenuItem key={item.value} value={item.value}>
            <S.FilterSelected>
              <S.PendencyAbbr>
                <div>{item.abbr}</div>
              </S.PendencyAbbr>
              <label>{item.label}</label>
            </S.FilterSelected>
          </S.StyledMenuItem>
        ))}
      </S.StyledSelect>
    </S.Wrapper>
  )
}
